/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.student'),
      field: 'student.fullName',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { student } = rowData;
        return (
          <span className="tooltip-test" title={student.fullName}>
            {student.fullName}
          </span>
        );
      },
    },
    {
      title: t('mnt_medication.name'),
      field: 'name',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { name } = rowData;
        return (
          <span className="tooltip-test" title={name}>
            {name}
          </span>
        );
      },
    },
    {
      title: t('mnt_medication.requester'),
      field: 'requester',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { requester } = rowData;
        return (
          <span className="tooltip-test" title={requester}>
            {requester}
          </span>
        );
      },
    },
    { title: t('mnt_medication.requestDate'), field: 'formattedrequestDate' },
    { title: t('general.status'), field: 'formattedStatus' },
  ];
}
